export const CustomProductItemFragment = /* GraphQL */ `
    advertencias
    antideslizante
    apertura_paraguas
    aroma
    blackout
    cantidad_de_hilos
    cantidad_de_hojas
    cantidad_de_luces
    cantidad_de_piezas
    cantidad_de_pilas
    capacidad
    capacidad_en_litros
    capacidad_en_ml
    card_price
    composicion
    cuidados
    diseno_pais_origen
    edad_recomendada_texto
    espacio_de_la_casa
    fijacion
    formato_de_fotos
    formato_libros
    frecuencia
    fuente_de_poder
    gramaje_del_papel
    gramos_por_pieza
    gsm
    g_talla
    hecho_a_mano
    incluye_bombilla_ampolleta
    instrucciones
    largo_del_cable
    medidas_de_embalaje_y_peso
    medidas_y_materialidad
    peso_maximo
    pintado_a_mano
    rese_a
    tamano_fotos
    tiempo_de_quemado
    tiempo_que_dura_el_agua_calien
    tipo_de_ampolleta
    tipo_de_conexion
    tipo_de_encuadernacion
    tipo_de_fijacion
    tipo_de_hojas
    tipo_de_luz
    tipo_de_mina
    tipo_de_pilas
    tipo_de_punta
    tipo_de_semilla
    tipo_de_sustrato
    tipo_de_tinta
    velas_led_tipo_de_luz
    voltaje
    watts
    qr_enabled
    ar_link
    diseno_consciente
    diseno_para_ti
  `
